import adminApiClient from './apiClient.js';

export const categoriaGruposApi = {
  list: async (params = {}) => {
    const { data } = await adminApiClient.get('/categoria-grupo/', { params });
    return data;
  },
  create: async (payload) => {
    const { data } = await adminApiClient.post('/categoria-grupo/', payload);
    return data;
  },
  update: async (id, payload) => {
    const { data } = await adminApiClient.put(`/categoria-grupo/${id}`, payload);
    return data;
  },
  remove: async (id) => {
    await adminApiClient.delete(`/categoria-grupo/${id}`);
  },
};

export default categoriaGruposApi;
